import {
  DEFAULT_COORDS,
  TOOLTIP_SAFE_SPACE,
  LEFT,
  RIGHT,
  TOP,
  BOTTOM
} from './consts'
import { IRef } from './types'
import { TPosition } from 'types'

export const getCoordsAndPosition = (
  tooltipRef: IRef,
  wrapperRef: IRef,
  preferredPosition: TPosition
): { x: number; y: number; position: TPosition } => {
  if (!tooltipRef.current || !wrapperRef.current)
    return { ...DEFAULT_COORDS, position: preferredPosition }

  const targetEl = wrapperRef.current

  const {
    left: targetLeft,
    right: targetRight,
    top: targetTop,
    width: targetWidth,
    height: targetHeight
  } = targetEl.getBoundingClientRect()

  const { width: tooltipWidth, height: tooltipHeight } =
    tooltipRef.current.getBoundingClientRect()

  const {
    left: parentContainerLeft,
    right: parentContainerRight,
    top: parentContainerTop,
    bottom: parentContainerBottom
  } = document.body.getBoundingClientRect()

  const commonX = targetLeft - tooltipWidth / 2 + targetWidth / 2
  const commonY = targetTop - tooltipHeight / 2 + targetHeight / 2

  const isSpaceAvailableToLeft = () =>
    targetLeft - parentContainerLeft >= tooltipWidth + TOOLTIP_SAFE_SPACE

  const isSpaceAvailableToRight = () =>
    parentContainerRight >= tooltipWidth + TOOLTIP_SAFE_SPACE

  const fitsCenteredHorizontally =
    commonX >= parentContainerLeft + TOOLTIP_SAFE_SPACE &&
    commonX + tooltipWidth <= parentContainerRight - TOOLTIP_SAFE_SPACE

  const isSpaceAvailableToTop =
    targetTop - parentContainerTop >= tooltipHeight + TOOLTIP_SAFE_SPACE &&
    fitsCenteredHorizontally

  const isSpaceAvailableToBottom =
    parentContainerBottom - targetTop >= tooltipHeight + TOOLTIP_SAFE_SPACE &&
    fitsCenteredHorizontally

  const availablePositions = [
    preferredPosition,
    LEFT,
    RIGHT,
    TOP,
    BOTTOM
  ].filter(position => {
    switch (position) {
      case TOP:
        return isSpaceAvailableToTop
      case LEFT:
        return isSpaceAvailableToLeft()
      case RIGHT:
        return isSpaceAvailableToRight()
      case BOTTOM:
        return isSpaceAvailableToBottom
      default:
        return false
    }
  })

  const position = (availablePositions[0] || preferredPosition) as TPosition

  const COORDS = {
    [TOP]: {
      x: commonX,
      y: targetTop - tooltipHeight - TOOLTIP_SAFE_SPACE
    },
    [BOTTOM]: {
      x: commonX,
      y: targetTop + targetHeight + TOOLTIP_SAFE_SPACE
    },
    [LEFT]: {
      x: targetLeft - tooltipWidth - TOOLTIP_SAFE_SPACE,
      y: commonY
    },
    [RIGHT]: {
      x: targetRight + TOOLTIP_SAFE_SPACE,
      y: commonY
    }
  }

  const x = COORDS[position].x
  const y = COORDS[position].y

  return { x, y, position }
}
